import { useEffect, useState } from "react";
import { BRAND, NAV_LINKS } from "@/mocks/melon";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 group">
          <span className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-background-50 shadow-sm">
            <span className="text-lg font-black leading-none">{BRAND.charAt(0)}</span>
            <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-accent-500 ring-2 ring-background-50 animate-pulse" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
              {BRAND}
              <span className="ml-1 text-primary-600">·实时瓜讯</span>
            </span>
            <span className="hidden sm:block text-[11px] text-foreground-500">{BRAND} · 全网热搜第一现场</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <a
              key={l.key}
              href={l.href}
              className="relative rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600 after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-0.5 after:h-0.5 after:w-0 after:rounded-full after:bg-primary-500 after:transition-all hover:after:w-6 whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <a
            href="#latest"
            className="inline-flex h-10 items-center gap-1.5 rounded-md px-4 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 whitespace-nowrap"
          >
            <i className="ri-search-line text-[15px]" />
            搜索瓜讯
          </a>
          <a
            href="#about"
            className="inline-flex h-10 items-center gap-1.5 rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-message-3-line text-[15px]" />
            爆料投稿
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex lg:hidden h-10 w-10 items-center justify-center rounded-md bg-background-100 text-foreground-800 cursor-pointer"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur px-4 pb-4 pt-2 md:px-6">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.key}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-3 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-message-3-line" /> 爆料投稿
            </a>
          </div>
        </div>
      )}
    </header>
  );
}

export default Navbar;